const Stats = () => {
  return (
<section className="py-16 bg-slate-50">
  <div className="max-w-7xl mx-auto px-4">
    
    {/* Heading */}
    <div className="text-center max-w-3xl mx-auto">
      <h2 className="text-4xl font-bold text-[#256ab7]">
        Why Choose Coolwell Coils
      </h2>

      <p className="mt-4 text-gray-500 leading-7">
        We provide premium HVAC coil solutions engineered for
        performance, durability, and energy efficiency for
        commercial and industrial applications.
      </p>
    </div>

    {/* Features Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
      
      {[
        {
          title: "Premium Quality",
          desc: "Manufactured with high-grade materials for long-lasting durability and reliable performance.",
        },
        {
          title: "Energy Efficient",
          desc: "Designed to maximize cooling and heating efficiency while reducing energy consumption.",
        },
        {
          title: "Custom Solutions",
          desc: "Tailored HVAC coil systems built according to your project requirements.",
        },
        {
          title: "Advanced Engineering",
          desc: "Precision-engineered products with modern manufacturing technology.",
        },
        {
          title: "Reliable Performance",
          desc: "Tested products that ensure consistent and dependable operation.",
        },
        {
          title: "Expert Support",
          desc: "Professional technical assistance and responsive customer service.",
        },
      ].map((item, i) => (
        <div
          key={i}
          className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300"
        >
          <div className="w-14 h-14 rounded-2xl bg-[#256ab7] text-white flex items-center justify-center text-xl font-bold">
            0{i + 1}
          </div>

          <h3 className="mt-6 text-xl font-semibold text-gray-900">
            {item.title}
          </h3>

          <p className="mt-3 text-gray-500 leading-7 text-sm">
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
  )
}

export default Stats